import React, { useState, useEffect } from 'react'
import StaffList from './StaffList/StaffList'
import DeletedEmployeeList from './DeletedEmployeesList/DeletedEmployeeList'
import ActionBar from './ActionBar/ActionBar'
import styles from './styles'
import AccessControl from '../../helpers/AccessControl/AccessControl'

export default function Settings(props) {

    const classes = styles()

    var [showStaff, setShowStaff] = useState(true)
    var [showDeletedStaff, setShowDeletedStaff] = useState(false)

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem('user'))
        if(user.roles.includes('finance') || user.roles.includes('client_group')){
            props.history.push('/app/reports')
        }
    }, [props.history])

    const showStaffList = () => {
        setShowStaff(true)
        setShowDeletedStaff(false)
    }

    const showDeletedEmployeesList = () => {
        setShowStaff(false)
        setShowDeletedStaff(true)
    }

    useEffect(() => {
		document.title = `CompKit - Settings`;
	  })

    return (
        <>
            <ActionBar showDeletedEmployeesList={showDeletedEmployeesList} showStaffList={showStaffList} showStaff={showStaff} showDeletedStaff={showDeletedStaff}></ActionBar>
            <div className={classes.root}>
				<AccessControl requiredPermissions={['staff_list']}>
                    {showStaff && <StaffList></StaffList>}
				</AccessControl>
                <AccessControl requiredPermissions={['archived_employees']}>
                    {showDeletedStaff && <DeletedEmployeeList></DeletedEmployeeList>}
				</AccessControl>
            </div>
        </>
    )
}
